angular
  .module("admin")
  .controller(
    "ListUsersCtrl",
    function ($uibModal, SupervisorsResource, $timeout) {
      this.pagination = {
        page: 1,
        pageSize: 10,
      };

      this.filters = {
        search: "",
        isActive: "true",
      };

      this.supervisors = [];
      this.metadata = {};
      this.searchTimeout = null;
      this.loading = false;

      this.loadData = function () {
        this.loading = true;
        var params = {
          page: this.pagination.page,
          limit: this.pagination.pageSize,
        };

        if (this.filters.search) {
          params.search = this.filters.search;
        }

        if (
          this.filters.isActive !== null &&
          this.filters.isActive !== undefined &&
          this.filters.isActive !== ""
        ) {
          params.isActive =
            this.filters.isActive === "true" || this.filters.isActive === true;
        }

        SupervisorsResource.query(params, (response) => {
          this.loading = false;
          if (response && response.data) {
            this.supervisors = response.data.data || [];
            this.metadata = response.data.metadata || {};
          } else {
            this.supervisors = [];
            this.metadata = {};
          }
        });
      };

      this.onSearchChange = function () {
        if (this.searchTimeout) {
          $timeout.cancel(this.searchTimeout);
        }
        this.pagination.page = 1;
        this.searchTimeout = $timeout(() => {
          this.loadData();
        }, 500);
      };

      this.onFilterChange = function () {
        this.pagination.page = 1;
        this.loadData();
      };

      this.toggle = function (user, e) {
        e.preventDefault();
        SupervisorsResource.toggle(
          { id: user.id },
          {},
          () => {
            this.loadData();
          },
          () => {
            this.loadData();
          }
        );
      };

      this.edit = function (user, e) {
        e.preventDefault();
        $uibModal
          .open({
            controller: "EditUsersCtrl",
            backdrop: "static",
            controllerAs: "ctrl",
            templateUrl: "views/admin/users/edit.html",
            resolve: {
              user: () => user,
            },
          })
          .result.then(() => this.loadData());
      };

      this.addUser = function (e) {
        e.preventDefault();

        $uibModal
          .open({
            controller: "CreateUserCtrl",
            backdrop: "static",
            controllerAs: "ctrl",
            templateUrl: "views/admin/users/create.html",
          })
          .result.then(() => this.loadData());
      };

      this.loadData();
    }
  )
  .config(function ($stateProvider) {
    $stateProvider.state("admin.users", {
      url: "users",
      templateUrl: "views/admin/users/list.html",
      controllerAs: "ctrl",
      controller: "ListUsersCtrl",
    });
  });
